export const openPdfInNewTab = (pdfUrl) => {
  window.open(pdfUrl, "_blank");
};

/** Privacy Policy, last updated August 2, 2026. Served from public/docs. */
export const PRIVACY_POLICY_PATH = '/docs/be-seen-privacy-policy-2026-08-02.pdf';

export const DOC_URLS = {
  termsAndConditionDoc: 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:c292598c-9385-41cc-8515-07888fd4c536',

  // Self-hosted from public/docs so the policy is version-controlled and ships with the app.
  // Update PRIVACY_POLICY_PATH when a new revision is published.
  // `privacyPolicyPayment` is kept as an alias — both used to point at different
  // (out-of-sync) documents; there is only one privacy policy.
  privacyPolicyDoc: PRIVACY_POLICY_PATH,
  privacyPolicyPayment: PRIVACY_POLICY_PATH,

  termsAndConditionPayment:"https://acrobat.adobe.com/id/urn:aaid:sc:AP:1cfc1b8b-649e-4887-816d-95b57b988b0e", //new

  providerPricingTermsDoc: 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:bfe2c30b-c384-4255-be0e-8c3c9b5401f6',
  // practiceProviderAgreementDoc:'https://acrobat.adobe.com/id/urn:aaid:sc:AP:2aac6b81-e8ba-4f08-b378-9db19b5bbb75',
  practiceProviderAgreementDoc:'https://acrobat.adobe.com/id/urn:aaid:sc:AP:bd9d5c6e-92a8-439f-93b1-6ac084545548', //new
  providerPricingTermsScheduleDoc:'https://acrobat.adobe.com/id/urn:aaid:sc:AP:42627fe1-b119-4b98-af7d-979ae8c112c6',
  disclaimerWithMedicareUpdate: "https://acrobat.adobe.com/id/urn:aaid:sc:AP:a598e197-472c-41af-9a64-14ea85236a2b", //new

}